import {call, put, takeLatest, take} from "redux-saga/effects";
import {
    getEventData,
    getResponseFailure,
    getResponseSuccess,
    getMessagesSuccess,
    getMessagesFailure,
    joinChatRoom, onConnectSuccess,
    getChatDentistsSuccess,
    getChatDentistsFailure
} from "./actions";
import socketIOClient from "socket.io-client";
import sailsIOClient from "../../../node_modules/sails.io.js/sails.io";
import {
    EVENT_ON_JOIN, EVENT_ON_LEAVE, EVENT_ON_MESSAGE, EVENT_ON_READ, GET_MESSAGES_REQUEST,
    GET_UNREAD_MESSAGES_COUNT_REQUEST,
    JOIN_ROOM_REQUEST, LEAVE_CHAT,
    POST_MESSAGE_REQUEST,
    READ_MESSAGE_REQUEST,
    EVENT_ON_RECONNECT,
    ON_CONNECT,
    ON_DISCONNECT, ON_NEW_USER, GET_CHAT_DENTISTS, 
} from "./constants";
import remote from "../../services/remote";
import {eventChannel, END} from "redux-saga";
import {getUsers} from "../Layouts/Admin/Dentists/actions";
import { getDataFailure } from "../Layouts/Admin/dashboard/actions";
import SentryManager from "../../monitoring/Sentry";

let io = {};


function getRequest(url) {
    return new Promise((resolve, reject) => {
        io.socket.get(url, (data, jwRes) => {
            if (jwRes.statusCode === 200) {
                resolve(data);
            } else {
                reject(jwRes);
            }
        })
    })
}

function postRequest({url, body}) {
    return new Promise((resolve, reject) => {
        io.socket.post(url, body, function gotResponse(data, jwRes) {
            if (jwRes.statusCode === 200) {
                resolve(data);
            } else {
                reject(jwRes);
            }
        });
    })
}

function socketEventListening(eventName) {
    return eventChannel(emitter => {
        if(eventName) {
            io.socket.on(eventName, function (data) {
                emitter(data);
            });
        } else {
            emitter(END);
        }
        return () => {
            console.log('Socket off')
        }
    });
}

function* _joinChatRoom(action) {
    let url = `/joinChatRoom`;
    if (action.userId) {
        url = `/joinChatRoom/${action.userId}`;
    }
    try {
        const response = yield call(getRequest, url);
        yield put(getResponseSuccess(response, 'join'))
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _sendMessage(action) {
    const url = `/sendMessage`;
    try {
        const response = yield call(postRequest, {url, body: action.data});
        yield put(getResponseSuccess(response, 'message'))
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _readMessage(action) {
    const url = `/readMessage/${action.messageId}`;
    try {
        const response = yield call(getRequest, url);
        yield put(getResponseSuccess(response, 'read'))
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _getNumberOfUnreadMessages(action) {
    const url = `/getNotifications`;
    try {
        const response = yield call(getRequest, url);
        yield put(getResponseSuccess(response, 'notifications'));
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _eventListenOnJoin(action) {
    try {
        const channel = yield call(socketEventListening, 'join');
        while (true) {
            const response = yield take(channel, 'join');
            yield put(getEventData(response));
        }
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _eventListenOnSendMessage(action) {
    try {
        const channel = yield call(socketEventListening, 'message');
        const url = `/getDentists`;
        while (true) {
            const response = yield take(channel, 'message');
            yield put(getEventData(response, 'getMessage'));
            if(action.role !== 'dentist'){
                const dentists = yield call(getRequest, url)
                yield put(getChatDentistsSuccess(dentists, 'getDentists'));
            } 
            
        }
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _eventListenOnRead(action) {
    try {
        const channel = yield call(socketEventListening, 'read');
        const url = `/getDentists`;
        while (true) {
            const response = yield take(channel, 'read');
            yield put(getEventData(response))
            if(action.role !== 'dentist'){
                const dentists = yield call(getRequest, url)
                yield put(getChatDentistsSuccess(dentists, 'getDentists'));
            } 
           ;
        }
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _eventListenOnLeave(action) {
    try {
        const channel = yield call(socketEventListening, 'leave');
        while (true) {
            const response = yield take(channel, 'leave');
            yield put(getEventData(response));
        }
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _eventListenOnNewUser(action) {
    try {
        const channel = yield call(socketEventListening, 'newUser');
        while (true) {
            const response = yield take(channel, 'newUser');
            yield put(getUsers());
        }
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _leaveChatRoom(action) {
    const url = `/leave`;
    try {
        const response = yield call(getRequest, url);
        yield put(getResponseSuccess(response, 'leave'));
    } catch (e) {
        yield put(getResponseFailure(e));
        SentryManager.captureException(e);
    }
}

function* _getMessages(action) {
    const url = `/get-messages/${action.page}/${action.partnerId}`;
    try {
        const response = yield call(remote, {
            route: url,
            method: 'get'
        });

        if (response.success) {
            yield put(getMessagesSuccess(response.data));
        } else {
            yield put(getMessagesFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* _eventOnReconnect(action) {
    try {
        let response = yield call(() => new Promise((resolve, reject) => {
            io.socket.on('reconnect', function () {
                resolve(true);
            })
        }));
        while (response) {
            yield put(joinChatRoom());
            response = yield call(() => new Promise((resolve, reject) => {
                io.socket.on('reconnect', function () {
                    resolve(true);
                })
            }));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* _onConnect() {

    if (!io.socket || !io.socket.isConnected()) {
        if (socketIOClient.sails) {
            io = socketIOClient;
            io.socket.reconnect();
        } else {
            io = sailsIOClient(socketIOClient);
            io.sails.url = process.env.REACT_APP_BASE_URL;
            io.sails.reconnection = true;
        }
    }
    yield put(onConnectSuccess())
}

function* _onDisconnect() {
    io.socket.disconnect();
    socketIOClient.sails = null;
}

function* _getChatDentists(action) {
    const url = `/getDentists`;
    try {
        const response = yield call(getRequest, url);
        yield put(getChatDentistsSuccess(response, 'getDentists'));
    } catch (e) {
        yield put(getChatDentistsFailure(e));
        SentryManager.captureException(e);
    }
}


export default function* watchChatSaga() {
    yield takeLatest(JOIN_ROOM_REQUEST, _joinChatRoom);
    yield takeLatest(POST_MESSAGE_REQUEST, _sendMessage);
    yield takeLatest(READ_MESSAGE_REQUEST, _readMessage);
    yield takeLatest(GET_UNREAD_MESSAGES_COUNT_REQUEST, _getNumberOfUnreadMessages);
    yield takeLatest(EVENT_ON_JOIN, _eventListenOnJoin);
    yield takeLatest(EVENT_ON_MESSAGE, _eventListenOnSendMessage);
    yield takeLatest(EVENT_ON_READ, _eventListenOnRead);
    yield takeLatest(EVENT_ON_LEAVE, _eventListenOnLeave);
    yield takeLatest(LEAVE_CHAT, _leaveChatRoom);
    yield takeLatest(GET_MESSAGES_REQUEST, _getMessages);
    yield takeLatest(EVENT_ON_RECONNECT, _eventOnReconnect);
    yield takeLatest(ON_CONNECT, _onConnect);
    yield takeLatest(ON_DISCONNECT, _onDisconnect);
    yield takeLatest(ON_NEW_USER, _eventListenOnNewUser);
    yield takeLatest(GET_CHAT_DENTISTS, _getChatDentists)
}



// WEBPACK FOOTER //
// ./src/containers/Chat/saga.js